import { Overrides } from '@material-ui/core/styles/overrides';

import { CORPORATE_COLORS } from '../colors/corporate';

export const listItemOverrides: Overrides = {
  MuiListItem: {
    divider: {
      borderBottom: '1px solid rgb(153 153 153)'
    },
    root: {
      '&.Mui-selected': {
        backgroundColor: CORPORATE_COLORS.BACKGROUND_PRIMARY_LOW
      }
    }
  }
};
